import React from "react";
import { MsalComponentContainer, MessageBox } from "./MsalComponentStyles.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

// msalErrorComponent.js
export const msalErrorComponent = ({ error }) => (
    <MsalComponentContainer>
      <MessageBox>
        <FontAwesomeIcon icon={faExclamationTriangle} size="3x" color="#FFD700" style={{paddingRight:"20px"}} />
        An Error Occurred during authorization: {error.errorCode}
      </MessageBox>
      </MsalComponentContainer>
  );